export default "__VITE_ASSET__A6eAz24j__"